<div class="sidebar">
    <app-sidebar-header [title]="INDRA_getTitle()" [label]="">
        <div actions>
            <button class="button button--small" [disabled]="INDRA_checkMiles()" (click)="!isModificationDisallowed ? INDRA_processAncillary() : INDRA_closeSidebar()" [attr.aria-label]="INDRA_getAriaLabelTranslation('confirmChanges') | ibeadmin:'sync'" *ngIf="!isServiceLoading && (INDRA_hasAddedAncillaries() || addedAncillary.length != 0)">
				{{ INDRA_getTextTranslation('done') | ibeadmin:'sync' }}
			</button>
        </div>
    </app-sidebar-header>

    <div class="sidebar__body sl--scrollable" #sidebar__body>
        <app-flight-route [flight]="flightRouteInput"></app-flight-route>

        <!-- LOADING -->
        <app-loading *ngIf="isServiceLoading"></app-loading>

        <ng-container *ngIf="!isServiceLoading">

            <div #sidebar__info>
                <!-- Ancillary Selection Error -->
                <div class="extras__helper-notification" *ngIf="selectionApiError">
                    <app-notification [style]="'alert'" [classes]="'alert-sidebar'" [icon]="'icons.svg#airport--delays'" [title]="INDRA_getOperationErrorNotificationTitle()">
                        <div message>
                            {{'cancelBooking.text.atThisMomentThisOperationCanNotBeDoneSorryByTheInconvenience' | ibeadmin:'sync'}}
                        </div>
                    </app-notification>
                </div>
            </div>

            <div #sidebar__info class="sidebar__info sidebar__info--columns">

                <div class="sidebar__info-text">
                    <ul class="vantages-listing">
                        <li>{{ INDRA_getTextTranslation('upToKg') | ibeadmin:'sync'}};</li>
                        <li>{{ INDRA_getTextTranslation('paymentMethod') | ibeadmin:'sync' }};</li>
                        <li>
                            {{ INDRA_getTextTranslation('specialConditions') | ibeadmin:'sync' }}
                            <a class="link">{{ INDRA_getTextTranslation('login') | ibeadmin:'sync' }}</a> {{ INDRA_getTextTranslation('frequentFlier') | ibeadmin:'sync' }}
                        </li>
                    </ul>
                    <a class="link link--external" (click)="INDRA_gotoURL('externalURLs.aboutBaggageRules')" href="javascript:;" [attr.aria-label]="INDRA_getAriaLabelTranslation('openDialog') | ibeadmin:'sync'">
						{{ INDRA_getTextTranslation('allAboutBaggage') | ibeadmin:'sync' }}
					</a>
                </div>
                <!-- <div class="sidebar__info-image" [style.background-image]="'url(assets/images/ancillaries/brand-extras/bags--small.jpg)'"></div> -->
            </div>


            <div class="flight">
                <div class="passenger" *ngFor="let passenger of passengers; let passenger_index = index">
                    <div class="passenger__details">
                        <h3 class="title-h3 passenger__name">
                            {{INDRA_printPassengerName(passenger)}}
                        </h3>
                        <div class="">
                            <span class="passenger__option">
								<app-svg svg="icons.svg#ancillaries--luggage"
									[tooltip]="INDRA_getBagCountsPerPassenger(passenger.idPax) + ' ' +  (INDRA_getTextTranslation('includedForPassenger') | ibeadmin:'sync') "
									aria-hidden="true" 
									[alt]="'Luggage icon'" >
								</app-svg>
								<!-- <app-svg aria-hidden="true" [ngClass]="['extras-feature__icon']" svg="icons.svg#{{'general--plus'}}" tooltip="{{'Hello'}}"></app-svg> -->
								<span>{{ INDRA_getBagCountsPerPassenger(passenger.idPax)}}</span>
                            </span>
                        </div>
                    </div>
                    <div class="passenger__actions">
                        <div class="passenger__action" *ngFor="let bag of INDRA_getAddedAncillariesForPassenger(passenger.idPax)">
                            <button class="button button-secondary button--icon-right" role="alert" aria-label="INDRA_printAddedButtonLabel(bag)">
								{{INDRA_printAddedButtonLabel(bag)}} {{INDRA_getTextTranslation('added') | ibeadmin:'sync'}}
								<app-svg svg="icons.svg#general--check" [alt]="'Added icon'"></app-svg>
								<span class="extra-price">({{ INDRA_printRemoveButtonLabel(bag) | indracurrency }})</span>
							</button>
                            <app-svg [ngClass]="['remove-extra']" [attr.aria-label]="INDRA_getAriaLabelTranslation('removeBag') | ibeadmin:'sync'" (click)="INDRA_handleRemoveAncillaryForBag(bag,passenger.idPax)" svg="icons.svg#general--close" [alt]="'Remove icon'" *ngIf="!isModificationDisallowed">
                            </app-svg>
                        </div>
                        <!-- button only if only one add on is available. -->
                        <div class="passenger__action" *ngIf="INDRA_getAddOnForPassenger(passenger.idPax).length > 0 && !isModificationDisallowed">
                            <button class="button" [attr.aria-label]="(INDRA_getTextTranslation('add') | ibeadmin:'sync') + ' ' + INDRA_printAddButtonLabel(passenger.idPax)" (click)="INDRA_handleAddAncillaryForBags(INDRA_getAddOnForPassenger(passenger.idPax)[0], passenger.idPax)">
								{{INDRA_getTextTranslation('add') | ibeadmin:'sync'}} {{INDRA_printAddButtonLabel(passenger.idPax) }}
							</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="extras__helper with-notification" *ngIf="(notificationShowing || (INDRA_checkOtherFlightAncillaries() && INDRA_hasAddedAncillaries())) && !isModificationDisallowed">
                <!-- IBETPIDOS-8850 : Removed "Apply the same to other flights" link
                <div class="extras__helper-actionable">
                    <a class="link" (click)="INDRA_handleApplyAll()" title="Apply your chosen extras to all the remaining flights">
						{{ INDRA_getTextTranslation('applyToOtherFlights') | ibeadmin:'sync' }}
					</a>
                </div> -->

                <div #sidebar__notification class="extras__helper-notification" role="status" tabindex="0" [class.is-showing]="notificationShowing" [attr.aria-hidden]="!notificationShowing">
                    {{ notificationMessage }}
                </div>
            </div>


            <div class="sidebar__payment_totals">
                <div class="total" *ngIf="INDRA_hasAddedAncillaries()">
                    <label class="label">{{ INDRA_printItemsCount() }} {{ INDRA_getTextTranslation('items')  | ibeadmin:'sync'}}</label>
                    <p class="value">{{ INDRA_printTotal() | indracurrency }}</p>
                </div>

                <app-extras-sidebar-miles-info *ngIf="!isModificationDisallowed" [milesNeeded]="milesNeeded" [addedAncillary]="addedAncillary" [payExtrasWithMiles]="payWithMiles" [notEnoughMilesFlag]="notEnoughMilesFlag" [hasAddedExtrasFlag]="hasAddedExtrasFlag" (isChecked)="INDRA_payAncillaryWithMiles($event)">
                </app-extras-sidebar-miles-info>

                <div class="flow_actions" *ngIf="INDRA_hasAddedAncillaries()">
                    <!-- IBETPIDOS-8890: Remove "Select for next flight button" -->
                    <!-- <app-flights-navigation [ancillaryType]="ancillariesType"></app-flights-navigation> -->
                </div>

                <div class="flow_actions" [ngClass]="INDRA_flowActionsClasses()" *ngIf="(INDRA_hasAddedAncillaries() || addedAncillary.length != 0) && !isModificationDisallowed">
                    <!--
					<button 
						class="button" 
						(click)="INDRA_handleNext()" 
						[attr.aria-label]="INDRA_getAriaLabelTranslation('selectNextFlight') | ibeadmin:'sync'"
						*ngIf="INDRA_hasNextFlight()">
						{{ INDRA_getTextTranslation('selectNextFlight') | ibeadmin:'sync' }}
					</button>
					-->
                    <button class="button" (click)="INDRA_processAncillary()" [disabled]="INDRA_checkMiles()" [attr.aria-label]="INDRA_getAriaLabelTranslation('closeDialog') | ibeadmin:'sync'">
						{{ INDRA_getTextTranslation('done') | ibeadmin:'sync' }}
					</button>
                </div>
            </div>

            <div class="sidebar-flight-text top-gap" *ngIf="!isMYB">
                <p>

                    {{ INDRA_getTextTranslation('checkedBaggagePerk') | ibeadmin:'sync' }}
                </p>
                <p>

                    {{ INDRA_getTextTranslation('tapVisaGoldPerk') | ibeadmin:'sync' }}
                </p>
                <a href="javascript:;" (click)="INDRA_gotoURL('externalURLs.compareLearnMore')" class="link extras-feature__link link--external" [attr.aria-label]="INDRA_getAriaLabelTranslation('openNewWindow') | ibeadmin:'sync'">
					{{ INDRA_getTextTranslation('learnMorePerks') | ibeadmin:'sync' }}
				</a>
            </div>

            <div class="conditions">
                <h3 class="title-h3 conditions__title">{{ INDRA_getTitleTranslation('conditions') | ibeadmin:'sync' }}</h3>
                <div class="conditions__text">
                    <div class="grid">
                        <div class="col-12">
                            <ul class="bullet-list">
                                <li>{{ INDRA_getTextTranslation('notTransferable') | ibeadmin:'sync' }}</li>
                                <li>{{ INDRA_getTextTranslation('notChangeable') | ibeadmin:'sync' }}</li>
                                <li>{{ INDRA_getTextTranslation('availableForFlight') | ibeadmin:'sync' }}</li>
                                <li>{{ INDRA_getTextTranslation('availableForHours') | ibeadmin:'sync' }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <a class="link link--external" href="javascript:;" (click)="INDRA_gotoURL('externalURLs.baggageTermsAndConditions')">
					{{ INDRA_getTextTranslation('allTermsAndConditions') | ibeadmin:'sync' }}
				</a>
            </div>
        </ng-container>
    </div>
    <div #sidebar__footer class="sidebar__footer ">
    </div>
</div>